import React, {PureComponent} from 'react';
import {Modal} from 'react-responsive-modal';
import {withTranslation} from "react-i18next";

class SessionClosedModal extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false,
        };

        this.openModal = this.openModal.bind(this);
        this.closeWindow = this.closeWindow.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.isSessionClosed !== this.props.isSessionClosed) {
            this.setState({
                modalOpen: this.props.isSessionClosed,
            });
        }
    }

    openModal() {
        this.setState({
            modalOpen: true
        });
    }

    closeWindow() {
        window.close();
        window.location.reload();
    }

    render() {
        return (
            <section>
                <Modal open={this.state.modalOpen}
                       onClose={() => {
                       }}
                       animationDuration={200}
                       center={true}
                       classNames={{modal: "small-modal fadeInLeft"}}
                       showCloseIcon={false}
                >
                    <div className={"row"}>
                        <div className={"col-sm-12"}>
                            <h3 className={"text-center"}><b className={"App_header"} style={{color: "#000000"}}>{this.props.t("sessionClosed")}!</b></h3>
                        </div>
                        <div className={"col-sm-12 text-center"} style={{paddingLeft: 35, paddingRight: 35}}>
                            <h3 className={"App_white_text"} style={{color: "#000000"}}>{this.props.t("sessionClosedWarning")}.</h3>
                        </div>
                        <div className={"col-sm-12 text-center"}>
                            <button
                                className={"btn App_white_text button"}
                                style={{background: "#ff0003", color: "#FFFFFF", marginBottom: 20}}
                                onClick={this.closeWindow}
                            >{this.props.t("ok")}
                            </button>
                        </div>
                    </div>
                </Modal>
            </section>
        );
    }
}

export default withTranslation("translations")(SessionClosedModal);